import { stationLookup } from '@jq4race/api-client';
import { useQuery } from '@tanstack/react-query';

export const STATION_LOOKUP_KEY = (accessToken: string, q: string) =>
  ['station-lookup', accessToken, q] as const;

/** Mirrors useSearchTickets, but authenticated via the station's own JWT, not the operator's. */
export function useStationLookup(accessToken: string | null, query: string) {
  return useQuery({
    queryKey: STATION_LOOKUP_KEY(accessToken ?? '', query),
    queryFn: async () => {
      if (!accessToken) return { results: [] };
      return stationLookup(accessToken, query);
    },
    enabled: Boolean(accessToken) && query.trim().length > 0,
  });
}
